import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormGroup, FormArray } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { Store } from '@ngrx/store';
import 'rxjs/Rx';

import { NavService } from './../navigation/navigation.service';
import { CVFormService } from './../coverage-form.service';

import {
  PaxFormControlService,
  BackendService,
  BobtailStore,
  UPDATE_STORE
} from './../../shared/index';
import { FormDriverInformationService } from './form-driver-information.service';

@Component({
  selector: 'pax-cf-form-driver-information',
  template: require('./form-driver-information.component.html'),
  providers: [
    PaxFormControlService,
    FormDriverInformationService
  ]
})
export class FormDriverInformationComponent implements OnInit, OnDestroy {
  formDriverInformation: FormGroup;
  questions: any[];
  questionsCurrentlyInsuredToggle: any[];
  questionsCurrentlyInsured: any[];
  questionsAccidentViolation: any[] = [];
  questionsClaims: any[] = [];
  questionsGroup1: any[] = [];
  questionsGroup2: any[] = [];
  questionOtherReasonForNoPriorInsurance: any;
  arrayAccidentViolation: FormArray;
  arrayClaims: FormArray;
  fgCurrentlyInsured: FormGroup;
  payload: Object = {};
  storeData;
  routeData;
  toggleClaims: boolean = false;
  formSubmitted = false;

  constructor(
    private _store: Store<any>,
    private _backend: BackendService,
    private FormControlService: PaxFormControlService,
    private dataService: FormDriverInformationService,
    private _router: Router,
    private _route: ActivatedRoute,
    private _cv: CVFormService,
    private _ns: NavService
  ) {}

  ngOnInit() {
    // resolve router data
    this.routeData = this._route.data.subscribe((data) => {
      this._store.dispatch({ type: UPDATE_STORE, payload: { steps: data['forms'][1], settings: data['forms'][0] } });
    });

    // get fields array from the service
    this.questions = this.dataService.getQuestions();
    this.questions.forEach(question => {
      if (question['key'] === 'areYouCurrentlyInsured') {
        this.questionsGroup2.push(question);
      } else {
        this.questionsGroup1.push(question);
      }
    });

    // init the form
    this.formDriverInformation = this.FormControlService.toFormGroup(this.questions);

    // toggle sub-form for "Are you currently insured?"
    this.formDriverInformation.controls['areYouCurrentlyInsured'].valueChanges.subscribe((value) => {
      if (value) {
        this.toggleClaims = true;
        this.questionsCurrentlyInsured = this.dataService.getCurrentlyInsured();
      } else {
        this.toggleClaims = false;
        this.questionsCurrentlyInsured = this.dataService.getCurrentlyNotInsured();
      }

      if (this.formDriverInformation.contains('currentlyInsured')) {
        this.formDriverInformation.removeControl('currentlyInsured');
      }
      this.fgCurrentlyInsured = this.FormControlService.toFormGroup(this.questionsCurrentlyInsured);
      this.formDriverInformation.addControl('currentlyInsured', this.fgCurrentlyInsured);

      if (this.fgCurrentlyInsured.contains('noPriorInsurance')) {
        this.fgCurrentlyInsured.controls['noPriorInsurance'].valueChanges.subscribe((valueNPI) => {
          if (valueNPI === 'оther') {
            this.addFieldOtherNoInsurance();
          } else {
            this.removeFieldOtherNoInsurance();
          }
        });
      }
    });

    // get data from store and prefill the form
    this.storeData = this._store.select('cvform').subscribe((store: BobtailStore) => {
      this.payload = store.steps['driver-information'];
      // payload is undefined on init, since the requested data comes later from server
      if (!this.payload) { return false; }
      // else patch the form
      if (this.payload.hasOwnProperty('arrayAccidentViolation')) {
        let arr = this.payload['arrayAccidentViolation'];
        arr.forEach(() => this.addRowAccidentViolation());
      }
      if (this.payload['areYouCurrentlyInsured'] && this.payload.hasOwnProperty('arrayClaims')) {
        let arr = this.payload['arrayClaims'];
        arr.forEach(() => this.addRowClaims());
      }
    });

    this.formDriverInformation.patchValue(this.payload || {});
  }

  ngOnDestroy() {
    this.storeData.unsubscribe();
    this.routeData.unsubscribe();
  }

  removeRowClaims(i: number) {
    this.questionsClaims.splice(i, 1);
    this.arrayClaims.removeAt(i);
  }

  addFieldOtherNoInsurance() {
    if (!this.fgCurrentlyInsured.contains('noPriorInsuranceOther')) {
      this.questionOtherReasonForNoPriorInsurance = this.dataService.getQuestionOtherReasonForNoPriorInsurance();
      this.questionsCurrentlyInsured.push(this.questionOtherReasonForNoPriorInsurance);
      this.fgCurrentlyInsured.addControl('noPriorInsuranceOther',
        this.FormControlService.toFormControl(this.questionOtherReasonForNoPriorInsurance));
    }
  }

  removeFieldOtherNoInsurance() {
    if (this.fgCurrentlyInsured.contains('noPriorInsuranceOther')) {
      this.questionsCurrentlyInsured.pop();
      this.fgCurrentlyInsured.removeControl('noPriorInsuranceOther');
    }
  }

  addRowClaims() {
    if (!this.formDriverInformation.contains('arrayClaims')) {
      this.arrayClaims = new FormArray([]);
      this.formDriverInformation.addControl('arrayClaims', this.arrayClaims);
    }
    this.questionsClaims.push(...[this.dataService.getClaimsQuestions()]);
    let group = this.FormControlService.toFormGroup(this.dataService.getClaimsQuestions());
    this.arrayClaims.push(group);
  }

  removeRowAccidentViolation(i: number) {
    this.questionsAccidentViolation.splice(i, 1);
    this.arrayAccidentViolation.removeAt(i);
  }

  addRowAccidentViolation() {
    if (!this.formDriverInformation.contains('arrayAccidentViolation')) {
      this.arrayAccidentViolation = new FormArray([]);
      this.formDriverInformation.addControl('arrayAccidentViolation', this.arrayAccidentViolation);
    }
    this.questionsAccidentViolation.push(...[this.dataService.getAccidentQuestion()]);
    let group = this.FormControlService.toFormGroup(this.dataService.getAccidentQuestion());
    this.arrayAccidentViolation.push(group);
  }

  onSubmit() {
    this.formSubmitted = true;

    this._cv.sendToServerAndUpdateStore('driver-information', this.formDriverInformation.value)
    .then(() => {
      this._ns.manualActiveStep('motor-carrier-information');
      this._router.navigate(['']);
    })
    .catch(err => console.log(err));
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./resources/themes/pandax/bobtail/app/coverage-form/form-driver-information/form-driver-information.component.ts